import React, { useState, useEffect, useCallback } from "react";
import {
  
  Card,
  CardContent,
  Typography,
  Box,
  
  CircularProgress,
} from "@mui/material";
import _ from "lodash";
import SearchTextField from "../../CustomComponant/SearchTextField";
import { DISPLAY_PAGE_SIZE } from "../../constants/constants";
import SriyanshCardHeader from "../../components/CardHeader";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";

import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import ListDynamicTable from "../../CustomComponant/ListDynamicTable.js";

function POExtension() {
  
  const [returnData, setReturnData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); // set the current page
  const pageSize = DISPLAY_PAGE_SIZE;
  const [pageLoader, setPageLoader] = useState(false);
  const [srcinddata, setSrcinddata] = useState("");
 
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  
  const handleRowClick = (row) => {
    
    viewData(row.PONumber);
  };
  const navigate = useNavigate();
  const viewData = (e) => {
    navigate("poUpdate", {
      state: {
        po_id: e,
      },
    });
  };

  const fetchData = useCallback(
    _.debounce(async (searchTerm) => {
      //setPageLoader(true);
      try {
        const response = await apiClient.post("/dpextendablePO", {
          vuname: uname,
          limit: String(pageSize * (currentPage - 1)),
          offset: String(pageSize),
          srcinddata: searchTerm,
        });
        setReturnData(response.data);
        setTotalRows(response.data[0]?.totaldata || 0);

      } catch (error) {
        setReturnData([]);
        setTotalRows(0);
      } finally {
        setPageLoader(false);
      }
    }, 300),
    [uname, currentPage, pageSize]
  );

  useEffect(() => {
    fetchData(srcinddata);
  }, [srcinddata, fetchData]);

  const columns = [
    "Shop",
    "party_name",
    //"party_contact",
    "IndentNumber",
    "PONumber",
    "PODate",
    "DPDate",
    "POItemName",
  ]; // keys from your data objects
  const columnNames = [
    "Consignee",
    "Supplier",
    //"Party Contact",
    "Indent Number",
    "PO Number",
    "PO Date",
    "DP Date",
    "Item Name",
  ];
  

  return (
    <div >
      {/* <SriyanshCardHeader Title="DP Date Extention" /> */}
      <Card className="Formcard ">
      <div className="input-groupHeading">
      DP Date Extention

            </div>
        <CardContent>
          {/* List 1: Available Consignees */}
          <div className="input-group">
            <Box
              sx={{
                width: "100%",
                border: "1px solid #ccc",
                borderRadius: 2,
                overflow: "auto",
                // maxHeight: 600, // Optional scrollable height
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: "8px",
                  borderBottom: "1px solid #ccc",
                  textAlign: "center",
                }}
              >
                Acceptable PO List
              </Typography>

              {/*-----------------------SEARCH BOX--------------------*/}

              {currentPage === 1 ? (
                <SearchTextField
                  label="PO Number"
                  value={srcinddata}
                  title="Enter PO Number"
                  onChange={(e) => setSrcinddata(e.target.value)}
                  adornment={
                    <IconButton title="Search PO">
                      <SearchIcon />
                    </IconButton>
                  }
                />
              ) : null}

              {/* ------------------------------LIST of Data ----------------------------*/}

              {pageLoader ? (
                <div className="loaderContainer">
                  {" "}
                  <CircularProgress />{" "}
                </div>
              ) : (
                <ListDynamicTable
                  columns={columns}
                  columnNames={columnNames}
                  data={returnData}
                  totalRows={totalRows}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  onRowClick={handleRowClick}
                />
              )}

              {/* <List>
                    {list1.map((item) => (
                      <ListItem
                        key={item.PONumber}
                        button
                        onClick={() => handleTransferToSelected(item)}
                      >
                        <ListItemText
                          primary={item.PONumber}
                          secondary={
                            <>
                            {item.DPDate} 
                            {item.PODate}
                            {item.party_name}
                          </>


                          } 
                        />
                      </ListItem>
                    ))}
                  </List> */}
            </Box>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default POExtension;
